import LenderSearchProgramsResults from './LenderSearchProgramsResults';

export default LenderSearchProgramsResults;
